<template>
    <div v-if="!regular || refundable !== undefined" v-intersect.once="onIntersect">
        <a v-if="regular" :class="labelColor">
            {{ label }}
        </a>
        <a v-else :class="labelColor" class="d-flex align-center" @click.prevent="showConditions">
            <v-icon size="small" start class="text-info">mdi-bell-alert-outline</v-icon>
            {{ label }}
        </a>
    </div>
</template>
<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {ConditionsLabel} from '~/components/snippets/ConditionsLabel.vue'

    @Component({})
    export class FlightConditionsLabel extends ConditionsLabel {
        @Prop() refundable
        @Prop() regular

        async onIntersect(isIntersecting) {
            if (!this.regular) {
                await super.onIntersect(isIntersecting)
            }
        }

        get isLoading() {
            if (!this.regular) {
                return super.isLoading
            } else {
                return false
            }
        }

        get hasErrors() {
            return !this.regular && super.hasErrors
        }

        get isFree() {
            return (!this.regular && super.isFree) || this.refundable
        }

        get isNonRefundable() {
            return (!this.regular && super.isNonRefundable) || this.refundable === false
        }

        get isFreeLabel() {
            return this.$t('refundable')
        }
    }

    export default FlightConditionsLabel
</script>

<style scoped>
    a {
        font-size: inherit;
        font-weight: inherit;
    }
</style>
